import {createFileRoute, redirect, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype'

import {localeAtom} from '@/lib/locale/locale'
import {expireOrder} from '@/services/orderService'
import {fallbackToDefault} from '@/utils/schema/fallback'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  cancel: false,
}

const cartSearchSchema = type({
  orderId: searchParamString.optional(),
  cancel: fallbackToDefault(type.boolean, DEFAULT_VALUES.cancel),
})

export const Route = createFileRoute('/cart/')({
  validateSearch: cartSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
  beforeLoad: ({search, context}) => {
    if (search.cancel && search.orderId) {
      const locale = context.store.get(localeAtom)

      void expireOrder({
        orderId: search.orderId,
        locale,
      })

      // eslint-disable-next-line @typescript-eslint/only-throw-error -- this is desired behavior
      throw redirect({
        to: Route.fullPath,
        replace: true,
      })
    }
  },
})
